export * from './firebase.app.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/~/angularfire2/app/index.js
// module id = ../../../../angularfire2/app/index.js
// module chunks = 3